<template>
  <div
    v-if="isExistSection"
    class="ticket-section"
    :class="{
      'no-margin': isValidPassAndCenteredQR,
      'centered-qr-section': isValidPassAndCenteredQR,
    }"
  >
    <div v-if="isValidPassAndCenteredQR" class="centered-qr-label">
      <div>利用区間（Section）</div>
    </div>
    <div v-else class="default-label">
      <div>利用区間</div>
      <div>Section</div>
    </div>
    <div
      v-if="fromStationName"
      class="value transform-size"
      :class="[
        sizeClass,
        isValidPassAndCenteredQR ? 'centered-qr-value' : 'default-value',
      ]"
    >
      {{ fromStationName }}<span v-if="!isLocalUse">から</span>
    </div>
    <div
      v-if="toStationName"
      class="value to-station transform-size"
      :class="[
        sizeClass,
        isValidPassAndCenteredQR ? 'centered-qr-value' : 'default-value',
        { 'no-margin': isValidPassAndCenteredQR },
      ]"
    >
      {{ toStationName }}<span>まで</span>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import passService from "@/services/pass";

export default {
  name: "BFaceSectionDisp",
  props: {
    price: {
      type: Object,
      required: true,
    },
    displaySectionType: {
      type: String,
      required: true,
    },
    isReturnTrip: {
      type: Boolean,
      required: false,
      default: false,
    },
    isValidPassAndCenteredQR: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const fromStationName = ref("");
    const toStationName = ref("");
    const fromStationSizeClass = ref("");
    const toStationSizeClass = ref("");
    const isLocalUse = passService.checkIsLocalUse(props.price);
    const isExistSection = props.displaySectionType != "none";

    const isExistFromStation = (displaySectionType) => {
      return (
        displaySectionType == "departure" ||
        displaySectionType == "arrival_and_departure"
      );
    };

    const isExistToStation = (displaySectionType) => {
      return (
        displaySectionType == "arrival" ||
        displaySectionType == "arrival_and_departure"
      );
    };

    const getSizeClass = (length) => {
      switch (true) {
        case length < 6:
          return "_10";
        case 6 < length < 10:
          return "_6";
        case 19 < length < 19:
          return "_4";
        case 18 < length:
          return "_3";
      }
    };

    const setSizeClasses = () => {
      fromStationSizeClass.value = getSizeClass(fromStationName.value);
      toStationSizeClass.value = getSizeClass(toStationName.value);
    };

    const setStationNames = () => {
      // isReturnTrip: trueの場合は、必ずdisplaySectionType: arrival_and_departure
      // 発駅・着駅どちらも存在する前提なので、存在チェックはしない
      if (props.isReturnTrip) {
        fromStationName.value = props.price.to_station.name;
        toStationName.value = props.price.from_station.name;
      } else {
        if (isExistFromStation(props.displaySectionType)) {
          fromStationName.value = props.price.from_station.name;
        }

        if (isExistToStation(props.displaySectionType)) {
          toStationName.value = props.price.to_station.name;
        }
      }
    };

    onMounted(() => {
      if (isExistSection) {
        setStationNames();
        setSizeClasses();
      }
    });

    return {
      isExistSection,
      isLocalUse,
      fromStationName,
      toStationName,
      fromStationSizeClass,
      toStationSizeClass,
    };
  },
};
</script>

<style lang="scss" scoped>
.ticket-section {
  width: 100%;
  margin-bottom: 12px;

  &.no-margin {
    margin-bottom: 0;
  }

  &.no-margin.centered-qr-section {
    width: 100%;
  }
}

.default-label {
  font-size: 11px;
  line-height: 21px;
}

.default-value {
  margin-top: 3px;
  font-size: 8vw;
  font-weight: bold;
}

.to-station {
  margin-top: 8px;

  &.no-margin {
    margin-top: 0;
  }
}

.transform-size {
  white-space: nowrap;
  transform-origin: top left;

  &.centered-qr-value {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
  }
}

._6 {
  transform: scale(0.6, 1);
}

._4 {
  transform: scale(0.4, 1);
}
._3 {
  transform: scale(0.3, 1);
}

.default-value span {
  font-size: 3.5vw;
}

.centered-qr-value span {
  font-weight: 700;
  font-size: 16px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
